function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import cn from 'classnames';
import isEmpty from 'lodash/isEmpty';
import React, { useContext, useEffect, useMemo, useRef, useState } from 'react';
import { Nav } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useRouteMatch } from 'react-router-dom';
import { useClickAway } from 'react-use';
import { Button } from '../../../../components/button';
import MembershipButton from '../../../../components/button/MembershipButton';
import FloatingScrollbar from '../../../../components/floatingScrollbar';
import CollapsibleNavItem from '../../../../components/navigation/CollapsibleNavItem';
import NavLink from '../../../../components/navigation/NavLink';
import TrialMembershipBar from '../../../../components/progressBar/TrialMembershipBar';
import useBreakpoint from '../../../../hooks/useBreakpoint';
import { useRedirect } from '../../../../hooks/useRedirect';
import useScreenWidthAndHeight from '../../../../hooks/useScreenWidthAndHeight';
import { alertWarning, hideModal, toggleSidenavVisibility } from '../../../../redux/actions';
import { profileSelectors } from '../../../../redux/selectors/profile';
import routes from '../../../../routes/constants';
import text from '../../../../text';
import { formatDate } from '../../../../utilities/date';
import { calculateRemainderDays, calculateRemainderHours, calculateTrialLengthDays } from '../../../../utilities/membership';
import { isRouteIncluded } from '../../../../utilities/routes';
import { getUserMembership, isUserAnonymous, userHasActiveMembership } from '../../../../utilities/user';
import { LayoutContext } from '../../../LayoutContext';
import GetStartedButton from '../onboarding/tour/GetStartedButton';
import useMembershipButton from '../../../../hooks/useMembershipButton';
import useHasProjectWithPointcloud from '../../../../mp/hooks/useHasProjectWithPointcloud';
import { START_TRIAL_MODAL } from '../../../../components/modal/StartTrialModal/StartTrialModal';
var ROUTES_TO_HIDE_SIDENAV = [
    routes.login,
    routes.password.create,
    routes.password.reset,
    routes.signUp,
    routes.order.root,
    routes.view3D.project(),
    routes.payment.job(),
    routes.payment.assignedStatus(),
    routes.user.membershipChangeSuccess,
    routes.user.membershipManagement,
    routes.statusPage.path,
    routes.mp.payment()
];
var isVisibleForRoute = function(r) {
    return !isRouteIncluded(ROUTES_TO_HIDE_SIDENAV)(r);
};
var getTrialRemainderMessage = function(membership) {
    var remainderHours = calculateRemainderHours(membership);
    var remainderDays = calculateRemainderDays(membership);
    var isDay = remainderHours > 24;
    var remainder = isDay ? remainderDays : remainderHours;
    return text('trialRemainder', {
        trialRemainder: function() {
            return /*#__PURE__*/ React.createElement("h3", {
                style: {
                    display: 'inherit',
                    fontFamily: 'Roboto, sans-serif'
                }
            }, "".concat(remainder));
        },
        remainder: remainder,
        isDay: isDay
    });
};
var Sidenav = function() {
    var _getUserMembership, _getUserMembership1;
    var handleMembershipClick = useMembershipButton().handleMembershipClick;
    var isUserUnderTrial = useSelector(profileSelectors.getIsUserUnderTrial);
    var is3dViewerEnabled = useSelector(profileSelectors.get3dViewerEnabled);
    var userHasValidMembership = useSelector(profileSelectors.hasValidMembership);
    var isUpgradeRecommended = useSelector(profileSelectors.getIsUpgradeRecommended);
    var canUserSeeTrialExpired = useSelector(profileSelectors.getCanUserSeeTrialExpired);
    var isEnabledForBreakpoint = useBreakpoint([
        'xs',
        'sm',
        'md'
    ]);
    var isVisibleForBreakpoint = useBreakpoint([
        'lg',
        'xl',
        'xxl'
    ]);
    var height = useScreenWidthAndHeight().height;
    var ref = useRef(null);
    var redirect = useRedirect();
    var location = useLocation();
    var dispatch = useDispatch();
    var _useState = _sliced_to_array(useState(routes.home), 2), activeKey = _useState[0], setActiveKey = _useState[1];
    var _useContext = useContext(LayoutContext), setStartNewProjectRef = _useContext.setStartNewProjectRef, startNewProjectHighlight = _useContext.startNewProjectHighlight;
    // To set active key for paths with params
    var match = useRouteMatch([
        routes.fileManager.viewProject(),
        routes.fileManager.root
    ]);
    // TODO: use useUser hook
    var _useSelector = useSelector(function(state) {
        return {
            sideNav: state.layout.sideNav,
            user: state.profileReducer.userProfile
        };
    }), sideNav = _useSelector.sideNav, user = _useSelector.user;
    var trialHasExpired = useMemo(function() {
        var membership = getUserMembership(user);
        return membership ? calculateRemainderHours(membership) <= 0 : false;
    }, [
        user
    ]);
    useEffect(function() {
        if (location.pathname && location.pathname !== activeKey) {
            setActiveKey((match === null || match === void 0 ? void 0 : match.path) || location.pathname);
            dispatch(toggleSidenavVisibility(false));
        }
    }, [
        location.pathname
    ]);
    useEffect(function() {
        if (isVisibleForRoute(location.pathname)) {
            if (isVisibleForBreakpoint) {
                dispatch(toggleSidenavVisibility(true));
            } else {
                dispatch(toggleSidenavVisibility(false));
            }
        }
    }, [
        isVisibleForBreakpoint,
        location.pathname
    ]);
    useClickAway(ref, function() {
        if (isEnabledForBreakpoint && sideNav.isVisible) {
            dispatch(toggleSidenavVisibility(false));
        }
    }, [
        'mousedown'
    ]);
    var _useHasProjectWithPointcloud = useHasProjectWithPointcloud(), hasProjectWithPointCloud = _useHasProjectWithPointcloud.hasPointCloud;
    var isLhs3dViewerDisabled = useMemo(function() {
        return !is3dViewerEnabled && hasProjectWithPointCloud && (!userHasValidMembership || isUpgradeRecommended);
    }, [
        is3dViewerEnabled,
        hasProjectWithPointCloud,
        userHasValidMembership,
        isUpgradeRecommended
    ]);
    var view3dTooltipText = isUpgradeRecommended ? text('upgrade') : text('startNdayTrial', {
        n: 14
    });
    var handle3dRedirect = function() {
        if (!isLhs3dViewerDisabled) {
            redirect.push(routes.view3DExternal.root);
            return;
        }
        var redirectConfig = {
            redirectTo: {
                path: routes.view3DExternal.root,
                label: text('navigateToRoute', {
                    navigation: 'Continue',
                    routeName: text('viewer3D')
                })
            }
        };
        var showWarningAlert = function() {
            dispatch(hideModal(START_TRIAL_MODAL));
            dispatch(alertWarning(/*#__PURE__*/ React.createElement("span", null, /*#__PURE__*/ React.createElement("a", {
                onClick: function() {
                    return handleMembershipClick(redirectConfig, false, function() {
                        return redirect.push(routes.view3DExternal.root);
                    }, {
                        onHide: showWarningAlert,
                        onStartTrial: function() {
                            return dispatch(hideModal(START_TRIAL_MODAL));
                        }
                    });
                },
                className: "mr-1 white-underlined-link"
            }, view3dTooltipText), text('accessThe3dViewer')), {
                className: 'v2 content-minus-sidenav'
            }));
        };
        handleMembershipClick(redirectConfig, false, function() {
            return redirect.push(routes.view3DExternal.root);
        }, {
            onHide: showWarningAlert,
            onStartTrial: function() {
                return dispatch(hideModal(START_TRIAL_MODAL));
            }
        });
    };
    return !isEmpty(user) && !isUserAnonymous(user) && /*#__PURE__*/ React.createElement("div", {
        ref: ref,
        className: cn('Sidenav d-flex flex-column justify-content-between', {
            show: sideNav.isVisible,
            hide: !isVisibleForRoute(location.pathname),
            'd-none': !isVisibleForRoute(location.pathname) && !isEnabledForBreakpoint
        })
    }, /*#__PURE__*/ React.createElement(FloatingScrollbar, {
        elementId: "nav-scrollbar-container",
        scollOffsetHeight: 24,
        thumbHeightSize: 80
    }, /*#__PURE__*/ React.createElement(Nav, {
        activeKey: activeKey
    }, /*#__PURE__*/ React.createElement(Nav.Item, null, /*#__PURE__*/ React.createElement(NavLink, {
        name: "dashboard",
        eventKey: routes.dashboard,
        onClick: function() {
            return redirect.push(routes.dashboard);
        },
        icon: "dashboard"
    })), /*#__PURE__*/ React.createElement(Nav.Item, null, /*#__PURE__*/ React.createElement(NavLink, {
        name: "viewer3D",
        eventKey: routes.view3DExternal.project(),
        onClick: handle3dRedirect,
        icon: "3D",
        isLocked: isLhs3dViewerDisabled
    })), /*#__PURE__*/ React.createElement(Nav.Item, {
        id: "map2D-nav-item"
    }, /*#__PURE__*/ React.createElement(NavLink, {
        name: "map2D",
        eventKey: routes.mp.root,
        onClick: function() {
            return redirect.push(routes.mp.root);
        },
        icon: "2d-map"
    })), /*#__PURE__*/ React.createElement(Nav.Item, null, /*#__PURE__*/ React.createElement(NavLink, {
        name: "fileManager",
        eventKey: (match === null || match === void 0 ? void 0 : match.path) || routes.fileManager.viewProject(),
        onClick: function() {
            return redirect.push(routes.fileManager.root);
        },
        icon: "file"
    })), /*#__PURE__*/ React.createElement(Nav.Item, null, /*#__PURE__*/ React.createElement(NavLink, {
        name: "account",
        eventKey: routes.user.profile,
        onClick: function() {
            return redirect.push(routes.user.profile);
        },
        icon: "profile"
    })), /*#__PURE__*/ React.createElement(CollapsibleNavItem, {
        header: text('larkiURL'),
        isBorderHighlighted: false,
        eventKey: routes.larkiWebsiteUrl.home,
        items: [
            {
                name: 'home',
                href: routes.larkiWebsiteUrl.home,
                isBorderHighlighted: false,
                isCaretHighlighted: false,
                target: '_blank'
            },
            {
                name: 'products',
                href: routes.larkiWebsiteUrl.products,
                isBorderHighlighted: false,
                isCaretHighlighted: false,
                target: '_blank'
            },
            {
                name: 'pricing',
                href: routes.larkiWebsiteUrl.pricing,
                isBorderHighlighted: false,
                isCaretHighlighted: false,
                target: '_blank'
            },
            {
                name: 'aboutUs',
                href: routes.larkiWebsiteUrl.aboutUs,
                isBorderHighlighted: false,
                isCaretHighlighted: false,
                target: '_blank'
            },
            {
                name: 'contactUs',
                href: routes.larkiWebsiteUrl.contactUs,
                isBorderHighlighted: false,
                isCaretHighlighted: false,
                target: '_blank'
            }
        ]
    }), /*#__PURE__*/ React.createElement(Nav.Item, {
        className: cn('start-new-project-item px-3', startNewProjectHighlight && 'highlight', {
            'pb-0': !startNewProjectHighlight && height >= 911
        }),
        ref: setStartNewProjectRef
    }, /*#__PURE__*/ React.createElement(Button, {
        className: "w-100",
        id: "button",
        variant: "primary",
        onClick: function() {
            redirect.push(routes.mp.root);
        }
    }, text('startNewProject'))), /*#__PURE__*/ React.createElement(Nav.Item, {
        id: "logout-nav-item"
    }, /*#__PURE__*/ React.createElement(NavLink, {
        name: "logout",
        eventKey: routes.logout,
        href: routes.logout
    })))), /*#__PURE__*/ React.createElement("div", {
        className: "Sidenav-Bottom position-relative h-auto pt-3"
    }, isUserUnderTrial ? calculateRemainderHours(getUserMembership(user)) > 0 ? /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("span", {
        className: "white d-inline-block text-center w-100  m-0 mb-1",
        style: {
            color: 'white'
        }
    }, getTrialRemainderMessage(getUserMembership(user)), " left"), /*#__PURE__*/ React.createElement(TrialMembershipBar, {
        membership: getUserMembership(user)
    }), /*#__PURE__*/ React.createElement("p", {
        className: "white text-center m-0 mb-2 mt-1"
    }, /*#__PURE__*/ React.createElement("small", null, text('trialLengthExpiryAt', {
        trialLength: "".concat(calculateTrialLengthDays(getUserMembership(user)), "-day"),
        expiryAt: formatDate((_getUserMembership = getUserMembership(user)) === null || _getUserMembership === void 0 ? void 0 : _getUserMembership.trial_end)
    })))) : null : canUserSeeTrialExpired && user.has_used_trial && !userHasActiveMembership(user) && trialHasExpired ? /*#__PURE__*/ React.createElement("p", {
        className: "text-center white"
    }, text('trialExpiredAt', {
        expiredAt: formatDate((_getUserMembership1 = getUserMembership(user)) === null || _getUserMembership1 === void 0 ? void 0 : _getUserMembership1.trial_end)
    })) : null, isUserUnderTrial ? /*#__PURE__*/ React.createElement("div", {
        className: "d-flex flex-row justify-content-center"
    }, /*#__PURE__*/ React.createElement("hr", {
        className: "mt-0 mb-3"
    })) : null, isUpgradeRecommended ? /*#__PURE__*/ React.createElement("p", {
        className: "white text-center mx-1 mb-3 font-12"
    }, text('upgradeToEssentials')) : null, /*#__PURE__*/ React.createElement("div", {
        className: "px-3"
    }, /*#__PURE__*/ React.createElement(MembershipButton, {
        className: "w-100 mb-2",
        isUppercase: true,
        isStarred: true
    })), /*#__PURE__*/ React.createElement("div", {
        className: "px-3"
    }, /*#__PURE__*/ React.createElement(GetStartedButton, null))));
};
export default Sidenav;
